import { render, staticRenderFns } from "./alert-widget.vue?vue&type=template&id=b1f52dec&scoped=true&"
import script from "./alert-widget.vue?vue&type=script&lang=js&"
export * from "./alert-widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f52dec",
  null
  
)

export default component.exports